import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "../../../global/unApi";
import Authorize from "../../../global/Authorize";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class AttStudent extends Component {
  state = {
    dateToday: new Date(),
    dateValue: null,
    attendence: {},
    loading: false,
    found: false,
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.fetchAttendence({
      month: this.state.dateToday.getMonth() + 1,
      year: this.state.dateToday.getFullYear(),
      roles: this.props.user.role.id,
      staff_info: this.props.user.staffData.id,
    });
    this.setState({
      dateValue: `${this.state.dateToday.getFullYear()}-${
        this.state.dateToday.getMonth > 9 ? "" : "0"
      }${this.state.dateToday.getMonth() + 1}`,
    });
  };

  fetchAttendence = (params = {}) => {
    this.setState({ loading: true });
    axios
      .get("/api/staffattendancemonthwise", { params: { ...params } })
      .then((res) => {
        if (res.data.length > 0)
          this.setState({
            attendence: res.data[0],
            loading: false,
            found: false,
          });
        else {
          this.setState({ found: true, loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleDateChange = (e) => {
    this.setState({ dateValue: e.target.value });
    this.fetchAttendence({
      month: e.target.value.split("-")[1],
      year: e.target.value.split("-")[0],
      roles: this.props.user.role.id,
      staff_info: this.props.user.staffData.id,
    });
  };

  render() {
    const { attendence } = this.state;
    const handelDt = (dt) => {
      var j = dt % 10,
        k = dt % 100;
      if (j === 1 && k !== 11) {
        return dt + "st";
      }
      if (j === 2 && k !== 12) {
        return dt + "nd";
      }
      if (j === 3 && k !== 13) {
        return dt + "rd";
      }
      return dt + "th";
    };
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const handleDate = (date1) => {
      let year1 = new Date(date1).getFullYear();
      let month1 = new Date(date1).getMonth();
      let dt1 = new Date(date1).getDate();

      year1 = year1 % 100;

      return `${handelDt(dt1)} ${monthNames[month1]}  ${year1}`;
    };
    return (
      <Authorize roles={["IS_TEACHER"]} redirect to="/login">
        <Header title={`Attendance`} />
        <div className="container">
          <div className="th-14 th-bold mt-3">Select Month</div>
          <div className="input-group input-group mb-3">
            <input
              className="form-control th-input-primary th-12"
              type="month"
              value={this.state.dateValue}
              onChange={this.handleDateChange}
              max
            ></input>
          </div>
        </div>

        {this.state.loading ? (
          <div className="container mt-3">
            <Skeleton width={150} />
            <Skeleton count={5} />
          </div>
        ) : this.state.found ? (
          <div className="container py-5 text-center th-12">
            <p className="mb-0 th-bold">No Data Avaliable</p>
            <p>Select different month</p>
          </div>
        ) : (
          <div>
            <div className="container">
              <div className="th-12 th-primary pt-2">General Details</div>
              <div className="my-2">
                <div className="row py-2">
                  <div className="col-6 th-12">Presents</div>
                  <div className="col-6 th-12 th-medium">
                    <div>{attendence.total_present}</div>
                  </div>
                </div>
                <hr className="my-0" />
                <div className="row py-2">
                  <div className="col-6 th-12">Absents</div>
                  <div className="col-6 th-12 th-medium">
                    <div>{attendence.total_absent}</div>
                  </div>
                </div>
                <hr className="my-0" />
                <div className="row py-2">
                  <div className="col-6 th-12">Halfdays</div>
                  <div className="col-6 th-12 th-medium">
                    <div>{attendence.total_halfday}</div>
                  </div>
                </div>
                <hr className="my-0" />
                <div className="row py-2">
                  <div className="col-6 th-12">Lates</div>
                  <div className="col-6 th-12 th-medium">
                    <div>{attendence.total_late}</div>
                  </div>
                </div>
              </div>
              <div className="th-12 th-primary pt-2 pb-2">Details</div>
              <table class="table table-striped th-12">
                <thead>
                  <tr>
                    <td className="th-medium">Day</td>
                    <td className="th-medium">Attendance</td>
                  </tr>
                </thead>

                <tbody>
                  {attendence.attendance
                    ? attendence.attendance?.map((item, index) => {
                        var status;
                        if (item.attendence_status === "present") status = "P";
                        else if (item.attendence_status === "absent")
                          status = "A";
                        else if (item.attendence_status === "halfday")
                          status = "HD";
                        else if (item.attendence_status === "late")
                          status = "L";
                        else if (item.attendence_status === "holiday")
                          status = "H";
                        else status = "-";
                        return (
                          <tr>
                            <td>{handleDate(item.date)}</td>
                            <td>{status}</td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Authorize>
    );
  }
}
export default withRouter(connect(mapStateToProps)(AttStudent));
